<div class="col-12 col-sm-11 col-md-11 col-lg-9 col-xl-9 col-xxl-9">
    <h1 class="c11n-text-xl-headline c11n-space-stack-6x">
        Choose the accounts to remove
        @if (granteeName$ | async; as granteeName) {
            {{ granteeName }}'s
        }
        @if (accessLevelLabel$ | async; as accessLevel) {
            {{ accessLevel | lowercase }}
        }
        access from
    </h1>

    @if (!isLoading) {
        @if (accountGroups$ | async; as groups) {
            <!-- Select All / Deselect All Link -->
            @if (groups.eligible?.length > 0) {
                <div>
                    <a
                            (click)="toggleSelectAll()"
                            (keydown.enter)="toggleSelectAll()"
                            class="select-all-link"
                            data-cy="select-all-link"
                            tabindex="0">
                        {{ allAccountsSelected ? 'Deselect all' : 'Select all' }}
                    </a>
                </div>
            }

            <!-- Eligible Accounts -->
            @if (groups.eligible?.length > 0) {
                <div class="c11n-space-stack-4x">
                    @for (account of groups.eligible; track account.accountId) {
                        <div class="eligible-account">
                            <c11n-checkbox
                                    (stateChange)="onAccountChange($event, account)"
                                    [attr.data-cy]="'account-checkbox-' + account.accountId"
                                    [labelText]="account.accountName">
                                <input
                                        [checked]="isAccountSelected(account)"
                                        [name]="'account-' + account.accountId"
                                        [value]="account.accountId"
                                        c11nCheckboxInput
                                        type="checkbox"/>
                            </c11n-checkbox>
                        </div>
                    }
                    <!-- Selection Error -->
                    @if (showSelectionError) {
                        <div #selectionError class="selection-error c11n-space-stack-3x" data-cy="selection-error"
                             role="alert">
                            <c11n-icon [name]="'error'" [size]="'small'"></c11n-icon>
                            <strong>Error:</strong> Please choose one or more accounts from the list.
                        </div>
                    }
                </div>
            }

            <!-- No Accounts Available Message -->
            @if (groups.eligible?.length === 0) {
                <c11n-banner
                        [hasCloseControl]="false"
                        [size]="'small'"
                        [variant]="'error'"
                        class="c11n-space-stack-4x"
                        data-cy="no-accounts-available-banner"
                        role="alert">
                    <div class="c11n-text-md--crop">
                        No accounts available.
                    </div>
                </c11n-banner>
            }
        }
    }
</div>
